import React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import { TextField } from '@mui/material';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import { Grid, Autocomplete } from '@mui/material'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import NewVendor from './NewVendor';
import ExpiredVendor from './ExpiredVendor/ExpiredVendor';
import OutsideNetwork from './OutsideNetwork/OutsideNetwork';
import VendorsInvited from './VendorsInvited/VendorsInvited';
import { HasScreenPermissions } from '../../utils/Token';
import INFO from '../../pages/commom/RouteUrlInfo.json';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function InviteVendorTab() {


  const params = new URLSearchParams(window.location.search);




  const handleChange = (event, newValue) => {
    setValue(newValue)
  };
  const StatusID = params.get("tab");

  const tabid = StatusID === "true" ? 3 : 0;
  const Permission = HasScreenPermissions(INFO?.InviteVendor?.actionName) ? 3 : tabid;
  const [value, setValue] = React.useState(Permission);

  return (
    <>
      <div style={{ padding: "20px" }}>
        <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
          <ToastContainer />

          <Grid item xs={12} sm={12} md={6} >
            <span style={{ fontSize: '28px', fontWeight: "600px", marginTop: "20px" }}>Invite Vendor</span>
          </Grid>

        </Grid>
      </div>
      <Tabs
        style={{ marginLeft: "-32px" }}
        className='mt-2'
        value={value}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons
        allowScrollButtonsMobile
        aria-label="scrollable force tabs example"
      >
        <Tab label="New Vendor"  {...a11yProps(0)} style={{ textTransform: "inherit" }} hidden={HasScreenPermissions(INFO?.InviteVendor?.actionName)} />
        <Tab label="Expired Vendor"  {...a11yProps(1)} style={{ textTransform: "inherit" }} hidden={HasScreenPermissions(INFO?.InviteVendor?.actionName)} />
        <Tab label="Outside Network"  {...a11yProps(2)} style={{ textTransform: "inherit" }} hidden={HasScreenPermissions(INFO?.InviteVendor?.actionName)} />
        <Tab label="Vendors Invited"  {...a11yProps(3)} style={{ textTransform: "inherit" }} />
      </Tabs>

      <TabPanel value={value} index={0} hidden={HasScreenPermissions(INFO?.InviteVendor?.actionName)}>
        <NewVendor />
      </TabPanel>
      <TabPanel value={value} index={1} hidden={HasScreenPermissions(INFO?.InviteVendor?.actionName)}>
        <ExpiredVendor />
      </TabPanel>
      <TabPanel value={value} index={2} hidden={HasScreenPermissions(INFO?.InviteVendor?.actionName)}>
        <OutsideNetwork />
      </TabPanel >
      <TabPanel value={value} index={3}>
        <VendorsInvited />
      </TabPanel >


    </>
  )
}

